import "../css/index.less";
import { Tools } from "../../common/func/tools/index.js";

class Rating {
  static getRateAvg(product_id) {
    $.ajax({
      url: "https://backend.1010diy.com:8086/web/reviewAvg?product_id=" + product_id,
      success: function (rt) {
        let data = JSON.parse(rt);
        let ratingValue = parseFloat(data).toFixed(1);
        $(".star-score").html(ratingValue);
      },
      error: function (rt) {
        console.log(rt);
      },
    });
  }
  static addStar(rate_value, product_id) {
    $.ajax({
      url: "https://backend.1010diy.com:8086/web/addStar/",
      type: "post",
      data: {
        product_id: product_id,
        value: rate_value,
      },
      success: function (rt) {
        let data = JSON.parse(rt);
        if (data.status == "ok") {
        }
      },
      error: function (rt) {
        console.log(rt);
      },
    });
  }
  static reviews(product_id) {
    $.ajax({
      url: "https://backend.1010diy.com:8086/web/reviewTotal?product_id=" + product_id,
      success: function (rt) {
        let data = JSON.parse(rt);
        if (data / 1000 > 1) {
          if (data / 10000 > 1) {
            data = (data / 10000).toFixed(1) + "M";
          } else {
            data = (data / 1000).toFixed(1) + "K";
          }
        }
        $(".star-count").html(data);
      },
    });
  }
}
// 日语文案优化
const copywriterOptimizationForJa = (currentLang = "") => {
  if (currentLang != "" && currentLang == "ja") {
    return {
      macOS: "macOS 11以降に対応",
      win: "Windows 11/10/8対応",
    };
  } else {
    return {
      macOS: "for macOS 11+",
      win: "for Windows 11/10/8",
    };
  }
};
// 轮播图初始化
const swiperInit = () => {
  const swiper = new Swiper(".mySwiper", {
    loop: false,
    spaceBetween: 24,
    on: {
      slideChange: function () {
        const currentIndex = this.activeIndex;
        const targetEle = $(".swiper-nav").children().get(currentIndex);
        $(targetEle)
          .addClass("nav-active")
          .siblings()
          .removeClass("nav-active");
      },
    },
  });
  const insideSwiper = new Swiper(".insideSwiper", {
    loop: false,
    spaceBetween: 24,
    allowTouchMove: false,
  });
  const insideSwiper1 = new Swiper(".insideSwiper1", {
    loop: false,
    spaceBetween: 24,
    allowTouchMove: false,
  });
  const insideSwiper2 = new Swiper(".insideSwiper2", {
    loop: false,
    spaceBetween: 24,
    allowTouchMove: false,
  });
  const insideSwiper3 = new Swiper(".insideSwiper3", {
    loop: false,
    spaceBetween: 24,
    allowTouchMove: false,
  });
  // inside switch
  $(".swiper-inside-nav").on("click", ".inside-nav-item", function () {
    const currentSwiper = $(this).parent().attr("data-swiper");
    let index = $(this).index();
    index = index > 0 ? index / 2 : index;
    switch (currentSwiper) {
      case "1":
        insideSwiper.slideTo(index);
        break;
      case "2":
        insideSwiper1.slideTo(index);
        break;
      case "3":
        insideSwiper2.slideTo(index);
        break;
      case "4":
        insideSwiper3.slideTo(index);
        break;
    }
    insideSwiper.slideTo(index);
    $(this)
      .addClass("inside-item-active")
      .siblings()
      .removeClass("inside-item-active");
  });
  // swiper switch
  $(".swiper-nav").on("click", "li", function () {
    const index = $(this).index();
    swiper.slideTo(index);
    $(this).addClass("nav-active").siblings().removeClass("nav-active");
    const $this = $(this); 
    const $swiperNav = $('.swiper-nav'); 
    
    const navWidth = $swiperNav.width(); 
    const navScrollLeft = $swiperNav.scrollLeft(); 
    const elementOffsetLeft = $this.offset().left - $swiperNav.offset().left; 
    const elementWidth = $this.outerWidth(); 
    
    // 计算元素在滚动容器中的完整位置
    const elementLeftInScroll = elementOffsetLeft + navScrollLeft; 
    const elementRightInScroll = elementLeftInScroll + elementWidth; 
    
    // 计算容器的可见区域
    const visibleLeft = navScrollLeft; 
    const visibleRight = navScrollLeft + navWidth; 
    
    // 判断元素是否被遮挡（考虑10px的缓冲区域）
    const isOverflowing = 
      elementLeftInScroll < visibleLeft + 10 || 
      elementRightInScroll > visibleRight - 10;
    
    if (isOverflowing) {
      // 计算目标滚动位置，使元素居中显示
      const targetScrollLeft = elementLeftInScroll - (navWidth / 2) + (elementWidth / 2);
      
      // 限制滚动范围
      const maxScrollLeft = $swiperNav[0].scrollWidth - navWidth;
      const finalPosition = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
      
      $swiperNav.animate({ 
        scrollLeft: finalPosition 
      }, 300); 
    }
  });
};

// 初始化faq模块
const initTabs = () => {
  let $handle = $('[data-handle="tab-handle"]');
  let $faqContent = $(".faq-content");
  $handle.on("click", function () {
    let $this = $(this);
    let type = $this.attr("data-value");
    $this.siblings().attr("data-active", "false");
    $this.attr("data-active", "true");
    switch (type) {
      case "faq":
        $faqContent.show();
        break;
    }
  });

  let $faqHandle = $('[data-handle="faq-handle"]');
  $faqHandle.on("click", function () {
    let $this = $(this);
    $this.parent().siblings().attr("data-active", "false");
    $this
      .parent()
      .attr(
        "data-active",
        $this.parent().attr("data-active") == "true" ? "false" : "true"
      );
  });
};
// 判断元素是否进入可视范围
const checkPosition = () => {
  $(".move-before").each(function () {
    let element = $(this);
    let offset = element.offset();
    if (offset) {
      var elementPosition = element.offset().top;
      var windowHeight = $(window).height();
      var scrollHeight = $(window).scrollTop();
      if (elementPosition < windowHeight + scrollHeight - 40) {
        element.addClass("move");
      }
    }
  });
};

// 初始化链接等
const initLinkAndPlatform = () => {
  const currentLang = $("html").attr("lang").toLowerCase();
  const downloadBtn = $('a[data-download="id3genius"]');
  if (Tools.isAndroid()) {
    downloadBtn.attr("data-platform", "android");
  } else if (Tools.isMac()) {
    downloadBtn.attr("data-platform", "mac");
    downloadBtn.attr("href", "/pro-mp3-tag-editor/download-mac/");
    downloadBtn.find('.text2').text(copywriterOptimizationForJa(currentLang).macOS)
  } else {
    downloadBtn.attr("data-platform", "win");
  }
  const buyDownload = $('a[data-buymore="id3genius"]');
  if (Tools.isPC()) {
    if (false && Tools.isMac()) {
      buyDownload.attr("href", "/store/buy-id3genius-mac/");
    } else {
      buyDownload.attr("href", "/store/buy-id3genius/");
    }
  } else if (Tools.isAndroid()) {
    buyDownload.attr("href", "/store/buy-id3genius/");
  } else if (false && Tools.isMac()) {
    buyDownload.attr("href", "/store/buy-id3genius-mac/");
  }
  const checkBtn = $('[data-handle="amoyDownloadTab"]');
  if (Tools.isPC()) {
    if (Tools.isMac()) {
      checkBtn.find(".macOS").attr("data-selected", "true");
      checkBtn.find(".windows").attr("data-selected", "false");
    } else {
      checkBtn.find(".windows").attr("data-selected", "true");
      checkBtn.find(".macOS").attr("data-selected", "false");
    }
  }
};
// 初始化点击事件
const initClick = () => {
  const currentLang = $("html").attr("lang").toLowerCase();
  const $productNav = $('[data-el="product-nav"]'),
    $openMobileMenu = $('[data-handle="open-mobile-menu"]'),
    $productNavMenu = $(".product-nav-menu");

  $(document)
    .on("click", "[data-handle='amoyDownloadTab'] .item", function () {
      let $this = $(this),
        $amoyDownload = $this.parent().parent().find(".download-btn"),
        $amoyBuy = $this.parent().parent().find(".buy-btn"),
        amoyPlatform = $this.attr("data-platform");
      const tempdownload = {
        win: "/pro-mp3-tag-editor/download-win/",
        mac: "/pro-mp3-tag-editor/download-mac/",
      };
      const tempBuy = {
        win: "/store/buy-id3genius/",
        mac: "/store/buy-id3genius-mac/",
      };
      const temptext = {
        mac: copywriterOptimizationForJa(currentLang).macOS,
        win: copywriterOptimizationForJa(currentLang).win,
        android: "for Android",
      };
      $this
        .attr("data-selected", "true")
        .siblings()
        .attr("data-selected", "false");
      $amoyDownload
        .attr("href", tempdownload[amoyPlatform])
        .attr("data-platform", amoyPlatform)
        .find(".text2")
        .text(temptext[amoyPlatform]);
      $amoyBuy
        .attr("href", tempBuy[amoyPlatform])
        .attr("data-platform", amoyPlatform);
    })
    .on("click", '[data-handle="open-mobile-menu"]', function (e) {
      e.stopPropagation();
      if ($(this).hasClass("arrow-top")) {
        $(this).removeClass("arrow-top");
        $productNavMenu.hide();
        $productNav.removeClass("product-nav-open");
        // BgScroll.recoveryScroll();
      } else {
        $(this).addClass("arrow-top");
        $productNavMenu.show();
        $productNav.addClass("product-nav-open");
        // BgScroll.forbidScroll();
      }
    })
    .on("click", '[data-el="product-nav"]', function () {
      $openMobileMenu.removeClass("arrow-top");
      $productNavMenu.hide();
      $productNav.removeClass("product-nav-open");
      // BgScroll.recoveryScroll();
    });

  const $subNavWrapper = $('[data-handle="subNavWrapper"]'),
    $headerBox = $('[data-element="headerBox"]');
  var p = 0,
    t = 0;
  $(window).scroll(function (e) {
    p = $(this).scrollTop();
    if (t <= p && t > 64) {
      $headerBox.addClass("hide");
      $subNavWrapper.css("top", "0");
    } else {
      $headerBox.addClass("hide");
      $subNavWrapper.css("top", "0");
    }

    if (t < 64) {
      $headerBox.removeClass("hide");
      $subNavWrapper.css("top", "64px");
      $productNav.hide();
    } else {
      $productNav.show();
    }
    setTimeout(function () {
      t = p;
    }, 0);
  });
};
// 滚动事件
const swiperNavScroll = () => {
  const swiperNav = $(".swiper-nav");
  if (!swiperNav.length) return;
  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;
  swiperNav
  .on("mousedown", function (e) {
    isDragging = true;
    startX = e.pageX - $(this).offset().left;
    scrollLeft = $(this).scrollLeft();
    $(this).css({
      'cursor': 'grabbing',
      'user-select': 'none'
    });
  })
  .on("mouseup", function (e) {
    if (isDragging) {
      isDragging = false;
      swiperNav.css({
        'cursor': 'grab',
        'user-select': ''
      });
    }
  })
  .on("mousemove", function (e) {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - swiperNav.offset().left;
    const walk = (x - startX) * 2;
    swiperNav.scrollLeft(scrollLeft - walk);
  })
}
const initRating = () => {
   $.fn.raty.defaults.path = "https://okmusi.com/asset/common/images/star/";

  $("#star-list").raty({
    score: 5,
    click: function (score, evt) {
      Rating.addStar(score, 892);
      Rating.getRateAvg(892);
      Rating.reviews(892);
    },
  });
  $("#star-list").find("img").attr({
    width: 24,
    height: 24,
  });

  Rating.getRateAvg(892);
  Rating.reviews(892);
}
$(() => {
  initTabs();
  checkPosition();
  initClick();
  initLinkAndPlatform();
  swiperNavScroll();
  swiperInit();
  initRating();
});
$(window).on("scroll resize", function () {
  checkPosition();
});